import React from "react";
import * as styles from "./BrochureLanguageSelector.module.scss";
import { SectionDivider, Select } from "@silversea-ssc/ui-components-react";
import { Trans } from "@lingui/macro";

interface BrochureLanguageSelectorProps {
  selectedLanguage: string;
  languages: {
    value: string;
    title: string;
  }[];
  onChange: (languageCode: string) => void;
}

const BrochureLanguageSelector: React.FC<BrochureLanguageSelectorProps> = ({
  selectedLanguage,
  onChange,
  languages = []
}) => {
  return (
    <SectionDivider
      backgroundColorTop="white"
      backgroundColorBottom="neutral05"
    >
      <div className={styles.container}>
        <label htmlFor="brochureLanguagesGroup" className={styles.label}>
          <Trans>Select the brochure language</Trans>
        </label>
        <Select
          id="brochureLanguagesGroup"
          className={styles.input}
          defaultValue={selectedLanguage}
          onChange={(e) => onChange(e.target.value)}
        >
          {languages.map((g) => (
            <option key={g.value} value={g.value}>
              {g.title}
            </option>
          ))}
        </Select>
      </div>
    </SectionDivider>
  );
};

export default BrochureLanguageSelector;
